import React, { useContext, useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { titleOpinionApi } from '~/api';
import { createNamedContext } from '~/util';

/**
 * @typedef TitleOpinionContext
 * @property {TitleOpinion} titleOpinion
 * @property {boolean} existingOpinion Indicates whether this title opinion is in our database
 */

/**@type {TitleOpinionContext} */
export const titleOpinionContext = createNamedContext('TitleOpinionContext');

/**
 * Hook for managing Title Opinion state
 * 
 * @returns {TitleOpinionContext} TitleOpinion State
 */
export const useTitleOpinion = () => useContext(titleOpinionContext);

export const withTitleOpinion = (Component) => {
    const ctx = useTitleOpinion();
    return <Component {...ctx} />;
};

export const ProvideTitleOpinion = ({ children }) => {
    const { id } = useParams();

    const opinion = useProvideTitleOpinion(id);
    return (
        <titleOpinionContext.Provider value={opinion}>
            {children}
        </titleOpinionContext.Provider>
    );
};

/**
 * 
 * @param {Number} id Title Opinion Id
 * @returns {TitleOpinionContext}
 */
export function useProvideTitleOpinion(id = 0) {
    const [titleOpinion, setTitleOpinion] = useState(null);

    const loadOpinion = async () => {
        if (id != 0) {
            const opinion = await titleOpinionApi.getTitleOpinion(id);

            setTitleOpinion(opinion);
        }
    };

    useEffect(() => loadOpinion(), [id]);

    const existingOpinion = useMemo(
        () => titleOpinion && Object.keys(titleOpinion).length > 0,
        [titleOpinion]);

    return {
        titleOpinion,
        existingOpinion
    };
}